export type VisitorLanguage = 'ro' | 'en';

/** Country comes from the same-origin backend, never browser language/storage. */
export async function loadVisitorLanguage(
  fetcher: typeof fetch = fetch,
  timeoutMs = 2_000,
): Promise<VisitorLanguage> {
  const controller = new AbortController();
  let timer: ReturnType<typeof setTimeout> | undefined;

  const fallback = new Promise<VisitorLanguage>((resolve) => {
    timer = setTimeout(() => {
      controller.abort();
      resolve('en');
    }, timeoutMs);
  });

  const detected = (async (): Promise<VisitorLanguage> => {
    try {
      const response = await fetcher('/api/locale', {
        signal: controller.signal,
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return 'en';
      const payload: unknown = await response.json();
      return payload !== null && typeof payload === 'object'
        && 'language' in payload && payload.language === 'ro' ? 'ro' : 'en';
    } catch {
      return 'en';
    }
  })();

  try {
    return await Promise.race([detected, fallback]);
  } finally {
    clearTimeout(timer);
    controller.abort();
  }
}
